// Styles
import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import CustomImage from "../Image";

export const FooterSection = styled.footer`
	padding: 64px 0 0 140px;
	${mediaMaxWidth.large`
    	padding: 64px 0 0 48px;
    `}
	${mediaMaxWidth.medium`
        padding: 24px 24px 40px;
    `}
	${mediaMaxWidth.mini`
        padding: 24px 12px 40px;
    `}
`;

export const FooterContent = styled.div`
	display: grid;
	grid-template-columns: 1fr 4fr;
	${mediaMaxWidth.medium`
        grid-template-columns: auto;
    `}
`;

export const FooterLinkContainer = styled.div`
	margin-top: 24px;
	display: grid;
	gap: 12px;
	grid-template-columns: 1fr 1fr 1fr;
	${mediaMaxWidth.medium`
	    grid-template-columns: 1fr 1fr;
    `}
`;

export const LogoContainer = styled.div`
	margin-top: 24px;
	object-fit: contain;
	& svg {
		box-shadow: 0 8px 20px 0px rgba(0, 0, 0, 0.17);
		border-radius: 15px;
		width: 80px;
		height: 80px;
	}

	${mediaMaxWidth.medium`
		& svg {
			box-shadow: 0 8px 20px 0px rgba(0, 0, 0, 0.17);
			border-radius: 10px;
			width: 50px;
			height: 50px;
		}
    `}
`;

export const LinkWrapper = styled.div``;

export const CategoryLinkWrapper = styled.div`
	${mediaMaxWidth.medium`
        grid-column: 1/ span 2;
    `}
`;

export const LinkText = styled.div`
	font-size: 12px;
	font-weight: bold;
	letter-spacing: 1.2px;
	color: #4d3951;
	text-transform: uppercase;
	${mediaMaxWidth.medium`
        font-size: 11px;
    `}
`;

export const FooterExtraLink = styled.div`
	display: grid;
	grid-template-columns: 1fr 4fr;
	${mediaMaxWidth.medium`
        grid-template-columns: 1fr;
	`}
`;

export const PlayStoreLinkWrapper = styled.div`
	${mediaMaxWidth.medium`
        display: none;
	`}
`;

export const EmptyDiv = styled.div`
	${mediaMaxWidth.medium`
        display: none;
	`}
`;

export const FooterExtraLinkContent = styled.div`
	margin-top: 24px;
	display: grid;
	gap: 12px;
	grid-template-columns: 1fr 1fr 1fr;
	${mediaMaxWidth.medium`
        grid-template-columns: 1fr 1fr;
	`}
`;

export const PeopleImage = styled(CustomImage)`
	object-fit: contain;
	${mediaMaxWidth.medium`
        display: none;
	`};
`;

export const PlaystoreImage = styled(CustomImage)`
	object-fit: contain;
`;

export const PlayStoreContainer = styled.div`
	margin-top: 30px;
	${mediaMaxWidth.medium`
        display: none;
	`}
`;

export const FooterSocialContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 2fr 2fr;
	margin-top: 48px;
	${mediaMaxWidth.medium`
        grid-template-columns: 1fr;
	`}
`;

export const CopyrightText = styled.div`
	font-size: 12px;
	color: #a5a5a5;
	margin-left: 15px;
	margin-top: 5px;
`;
export const FooterInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
`;
export const FooterDetailsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 60px;
`;
export const FooterBottomContainer = styled.div`
	display: flex;
`;

export const ImageContainer = styled.div`
	${mediaMaxWidth.medium`
        display: none;
    `}
`;
export const FooterLogosTextContainer = styled.div`
	display: flex;
	flex-direction: column;
`;
export const FooterImageContainer = styled.div`
	flex: 1;
`;
export const Hr = styled.hr`
	background-color: rgba(216, 216, 216, 0.5);
	margin: 22px 0;
`;
export const FooterLogosWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
`;
export const TextContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;
	& div {
		line-height: normal;
	}
`;
export const Text = styled.div`
	& a {
		font-size: 14px;
		color: #6a6a6a;
		text-decoration: none;
		margin-right: 15px;
	}
`;

export const BrandLinesContainer = styled.div`
	display: flex;
	margin-top: -6px;
	position: relative;
	z-index: 0;
	${mediaMaxWidth.medium`
        display: none;
    `}
`;
export const BrandLines = styled.div`
	height: 6px;
	width: 100%;
	background-color: ${({ backgroundColor }) => backgroundColor};
`;
export const SocialMediaLogosWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;

	& a:not(:first-child) {
		margin-left: 15px;
	}
	${mediaMaxWidth.medium`
        & a:not(:first-child) {
            margin-left: 10px;
        }
    `}
`;
